const route = [
  {
    path: '/hospital/healthArchive/home',
    name: 'healthArchive',
    component: () => import(/* webpackPrefetchPlaceHolder */ './home'),
    auth: false,
    exact: true,
    title: '健康档案',
  },
  {
    path: '/hospital/healthArchive/servicesHistory',
    name: 'servicesHistory',
    component: () => import(/* webpackPrefetchPlaceHolder */ './servicesHistory'),
    auth: true,
    exact: true,
    title: '服务记录',
  },
  {
    path: '/hospital/healthArchive/serviceDetail',
    name: 'serviceDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './serviceDetail'),
    auth: true,
    exact: true,
    title: '服务记录',
  },
  {
    path: '/hospital/healthArchive/serviceEvaluate',
    name: 'serviceEvaluate',
    component: () => import(/* webpackPrefetchPlaceHolder */ './serviceEvaluate'),
    auth: true,
    exact: true,
    title: '评价',
  },
];

export default route;

